export default __webpack_public_path__ + "static/media/exit.0d972b44.svg";